import { create } from 'zustand'

export interface DocumentEditSessionEntry {
  lockedByOther: boolean
  holderName: string | null
}

const DEFAULT_ENTRY: DocumentEditSessionEntry = {
  lockedByOther: false,
  holderName: null,
}

interface DocumentEditSessionState {
  sessions: Record<string, DocumentEditSessionEntry>
  setSession: (documentId: string, entry: DocumentEditSessionEntry) => void
  clearSession: (documentId: string) => void
}

export const useDocumentEditSessionStore = create<DocumentEditSessionState>(
  (set) => ({
    sessions: {},

    setSession: (documentId, entry) =>
      set((state) => ({
        sessions: { ...state.sessions, [documentId]: entry },
      })),

    clearSession: (documentId) =>
      set((state) => {
        if (!(documentId in state.sessions)) return state
        const sessions = { ...state.sessions }
        delete sessions[documentId]
        return { sessions }
      }),
  }),
)

export function getDocumentEditSession(
  documentId: string,
): DocumentEditSessionEntry {
  return (
    useDocumentEditSessionStore.getState().sessions[documentId] ?? DEFAULT_ENTRY
  )
}
